import _slicedToArray from "/Users/eriksuen/Documents/digigear/projects/dgg-websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { WalletReadyState } from '@solana/wallet-adapter-base';
import { useWallet } from '@solana/wallet-adapter-react';
import React, { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Collapse } from './Collapse.mjs';
import { useWalletModal } from './useWalletModal.mjs';
import { WalletListItem } from './WalletListItem.mjs';
import { WalletSVG } from './WalletSVG.mjs';
export var WalletModal = function WalletModal(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? 'body' : _ref$container;
  var ref = useRef(null);

  var _useWallet = useWallet(),
      wallets = _useWallet.wallets,
      select = _useWallet.select;

  var _useWalletModal = useWalletModal(),
      setVisible = _useWalletModal.setVisible;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      fadeIn = _useState4[0],
      setFadeIn = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      portal = _useState6[0],
      setPortal = _useState6[1];

  var _useMemo = useMemo(function () {
    var installed = [];
    var notDetected = [];
    var loadable = [];

    var _iterator = _createForOfIteratorHelper(wallets),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var wallet = _step.value;

        if (wallet.readyState === WalletReadyState.NotDetected) {
          notDetected.push(wallet);
        } else if (wallet.readyState === WalletReadyState.Loadable) {
          loadable.push(wallet);
        } else if (wallet.readyState === WalletReadyState.Installed) {
          installed.push(wallet);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [installed, [].concat(loadable, notDetected)];
  }, [wallets]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      installedWallets = _useMemo2[0],
      otherWallets = _useMemo2[1];

  var getStartedWallet = useMemo(function () {
    return installedWallets.length ? installedWallets[0] : wallets.find(function (wallet) {
      return wallet.adapter.name === 'Torus';
    }) || wallets.find(function (wallet) {
      return wallet.adapter.name === 'Phantom';
    }) || wallets.find(function (wallet) {
      return wallet.readyState === WalletReadyState.Loadable;
    }) || otherWallets[0];
  }, [installedWallets, wallets, otherWallets]);
  var hideModal = useCallback(function () {
    setFadeIn(false);
    setTimeout(function () {
      return setVisible(false);
    }, 150);
  }, []);
  var handleClose = useCallback(function (event) {
    event.preventDefault();
    hideModal();
  }, [hideModal]);
  var handleWalletClick = useCallback(function (event, walletName) {
    select(walletName);
    handleClose(event);
  }, [select, handleClose]);
  var handleCollapseClick = useCallback(function () {
    return setExpanded(!expanded);
  }, [expanded]);
  var handleTabKey = useCallback(function (event) {
    var node = ref.current;
    if (!node) return; // here we query all focusable elements

    var focusableElements = node.querySelectorAll('button');
    var firstElement = focusableElements[0];
    var lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey) {
      // if going backward by pressing tab and firstElement is active, shift focus to last focusable element
      if (document.activeElement === firstElement) {
        lastElement.focus();
        event.preventDefault();
      }
    } else {
      // if going forward by pressing tab and lastElement is active, shift focus to first focusable element
      if (document.activeElement === lastElement) {
        firstElement.focus();
        event.preventDefault();
      }
    }
  }, [ref]);
  useLayoutEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Escape') {
        hideModal();
      } else if (event.key === 'Tab') {
        handleTabKey(event);
      }
    }; // Get original overflow


    var _window$getComputedSt = window.getComputedStyle(document.body),
        overflow = _window$getComputedSt.overflow; // Hack to enable fade in animation after mount


    setTimeout(function () {
      return setFadeIn(true);
    }, 0); // Prevent scrolling on mount

    document.body.style.overflow = 'hidden'; // Listen for keydown events

    window.addEventListener('keydown', handleKeyDown, false);
    return function () {
      // Re-enable scrolling when component unmounts
      document.body.style.overflow = overflow;
      window.removeEventListener('keydown', handleKeyDown, false);
    };
  }, [hideModal, handleTabKey]);
  useLayoutEffect(function () {
    return setPortal(document.querySelector(container));
  }, [container]);
  return portal && createPortal(React.createElement("div", {
    "aria-labelledby": "wallet-adapter-modal-title",
    "aria-modal": "true",
    className: "wallet-adapter-modal ".concat(fadeIn && 'wallet-adapter-modal-fade-in', " ").concat(className),
    ref: ref,
    role: "dialog"
  }, React.createElement("div", {
    className: "wallet-adapter-modal-container"
  }, React.createElement("div", {
    className: "wallet-adapter-modal-wrapper"
  }, React.createElement("button", {
    onClick: handleClose,
    className: "wallet-adapter-modal-button-close"
  }, React.createElement("svg", {
    width: "14",
    height: "14"
  }, React.createElement("path", {
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  }))), installedWallets.length ? React.createElement(React.Fragment, null, React.createElement("h1", {
    className: "wallet-adapter-modal-title"
  }, "Connect a wallet on Solana to continue"), React.createElement("ul", {
    className: "wallet-adapter-modal-list"
  }, installedWallets.map(function (wallet) {
    return React.createElement(WalletListItem, {
      key: wallet.adapter.name,
      handleClick: function handleClick(event) {
        return handleWalletClick(event, wallet.adapter.name);
      },
      wallet: wallet
    });
  }), otherWallets.length ? React.createElement(Collapse, {
    expanded: expanded,
    id: "wallet-adapter-modal-collapse"
  }, otherWallets.map(function (wallet) {
    return React.createElement(WalletListItem, {
      key: wallet.adapter.name,
      handleClick: function handleClick(event) {
        return handleWalletClick(event, wallet.adapter.name);
      },
      tabIndex: expanded ? 0 : -1,
      wallet: wallet
    });
  })) : null), otherWallets.length ? React.createElement("button", {
    className: "wallet-adapter-modal-list-more",
    onClick: handleCollapseClick,
    tabIndex: 0
  }, React.createElement("span", null, expanded ? 'Less ' : 'More ', "options"), React.createElement("svg", {
    width: "13",
    height: "7",
    viewBox: "0 0 13 7",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(expanded ? 'wallet-adapter-modal-list-more-icon-rotate' : '')
  }, React.createElement("path", {
    d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
  }))) : null) : React.createElement(React.Fragment, null, React.createElement("h1", {
    className: "wallet-adapter-modal-title"
  }, "You'll need a wallet on Solana to continue"), React.createElement("div", {
    className: "wallet-adapter-modal-middle"
  }, React.createElement(WalletSVG, null), React.createElement("button", {
    type: "button",
    className: "wallet-adapter-modal-middle-button",
    onClick: function onClick(event) {
      return handleWalletClick(event, getStartedWallet.adapter.name);
    }
  }, "Get started")), otherWallets.length ? React.createElement(React.Fragment, null, React.createElement("button", {
    className: "wallet-adapter-modal-list-more",
    onClick: handleCollapseClick,
    tabIndex: 0
  }, React.createElement("span", null, expanded ? 'Hide ' : 'Already have a wallet? View ', "options"), React.createElement("svg", {
    width: "13",
    height: "7",
    viewBox: "0 0 13 7",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(expanded ? 'wallet-adapter-modal-list-more-icon-rotate' : '')
  }, React.createElement("path", {
    d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
  }))), React.createElement(Collapse, {
    expanded: expanded,
    id: "wallet-adapter-modal-collapse"
  }, React.createElement("ul", {
    className: "wallet-adapter-modal-list"
  }, otherWallets.map(function (wallet) {
    return React.createElement(WalletListItem, {
      key: wallet.adapter.name,
      handleClick: function handleClick(event) {
        return handleWalletClick(event, wallet.adapter.name);
      },
      tabIndex: expanded ? 0 : -1,
      wallet: wallet
    });
  })))) : null))), React.createElement("div", {
    className: "wallet-adapter-modal-overlay",
    onMouseDown: handleClose
  })), portal);
};